import React, { useEffect, useState } from "react";
import API from "../services/api";
import { toast } from "react-toastify";
import AuditTable from "../components/AuditTable";
import { RefreshCw } from "lucide-react";

const AuditPage = () => {
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading]     = useState(false);

  const fetchAuditLogs = async () => {
    try {
      setLoading(true);
      const res = await API.get("/admin/audit-logs");
      setAuditLogs(res.data);
    } catch (err) {
      toast.error("Failed to load audit logs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAuditLogs(); }, []);

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-primary">Audit Logs</h2>
          <p className="text-sm text-gray-400 mt-0.5">Full activity trail for all application actions</p>
        </div>
        <button
          onClick={fetchAuditLogs}
          className="flex items-center gap-2 bg-secondary text-white px-4 py-2 rounded-xl text-sm hover:bg-blue-700 active:scale-95 transition-all duration-200"
        >
          <RefreshCw size={14} className={loading ? "animate-spin" : ""} />
          Refresh
        </button>
      </div>

      {loading ? (
        <div className="flex flex-col items-center py-14 gap-3">
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-400 text-sm">Loading logs...</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4">
          <AuditTable auditLogs={auditLogs} />
        </div>
      )}
    </div>
  );
};

export default AuditPage;